// extracted by mini-css-extract-plugin
export var basicSlide__btnGroup = "basic-slide-module--basic-slide__btn-group--afec5";
export var basicSlide__btnGroup__button = "basic-slide-module--basic-slide__btn-group__button--07ff7";
export var basicSlide__caption = "basic-slide-module--basic-slide__caption--ef0cb";
export var basicSlide__captionDarkMode = "basic-slide-module--basic-slide__caption--dark-mode--fa3cf";
export var basicSlide__eyebrow = "basic-slide-module--basic-slide__eyebrow--51b00";
export var basicSlide__eyebrowDarkMode = "basic-slide-module--basic-slide__eyebrow--dark-mode--5eb09";
export var basicSlide__form = "basic-slide-module--basic-slide__form--60080";
export var basicSlide__title = "basic-slide-module--basic-slide__title--55a8c";
export var basicSlide__titleDarkMode = "basic-slide-module--basic-slide__title--dark-mode--1c75d";
export var mt0 = "basic-slide-module--mt-0--ddc99";
export var mt1 = "basic-slide-module--mt-1--b18e6";
export var mt2 = "basic-slide-module--mt-2--40d22";
export var mt3 = "basic-slide-module--mt-3--3e45b";
export var mt4 = "basic-slide-module--mt-4--30930";
export var mt5 = "basic-slide-module--mt-5--a391d";
export var mt6 = "basic-slide-module--mt-6--8ae3b";